import { render } from "./TargetView.vue?vue&type=template&id=3a899a6c"
import script from "./TargetView.vue?vue&type=script&lang=js"
export * from "./TargetView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__